module.exports = __webpack_public_path__ + "static/media/share-icon2.c707914d.svg";